export default {
    none: 'none',
    historic: 'historic',
    showCard: 'showCard',
    showCardSwipeOut: 'showCardSwipeOut',
    showCardAwardCompetence: 'showCardAwardCompetence',
    spotCheck: 'spotCheck',
    swipeIn: 'swipeIn',
    swipeOut: 'swipeOut',
    awardCompetence: 'awardCompetence',
    awardPendingCompetence: 'awardPendingCompetence'
};